import React from "react";

const ProfileImage = ({size=30, name = "Sample", bgcolor="red"}) => {
  if (name === "") return  <></>
  
  const nameParts = name[0] + name[1]
  return (
    <span style={{
        display:"flex",
        justifyContent: "center",
        alignItems: "center",
        width: size,
        height: size,
        backgroundColor: bgcolor,
        color: "black",
        fontSize: size * 0.4,
        borderRadius: "50%",
        fontWeight: "500",
    }}>
        {nameParts.toUpperCase()}
    </span>
  );
};
export default ProfileImage;